import { Box, Button, IconButton, Typography } from "@mui/material";
import styled from "styled-components";

export const ModalBox = styled(Box)`
  display: flex;
  flex-direction: column;
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  width: 40rem;
  height: 33rem;
  position: absolute;
  top: 50%;
  left: 50%;
  outline: none;
  transform: translate(-50%, -50%);
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
`;

export const HeaderContainer = styled.div`
  display: flex;
  border-bottom: 2px solid black;
  align-items: center;
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  margin-left: 15px;
  padding-bottom: 10px;
`;

export const TitleSectionHead = styled.h3`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  padding: 0px 0px 0px 20px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const TitleSectionPara = styled.p`
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  opacity: 0.4;
  padding: 0px 0px 0px 20px;
  margin-top: 0px;
  margin-bottom: 10px;
`;

export const CloseButton = styled(IconButton)`
  && {
    position: absolute;
    top: 10px;
    right: 10px;
    border-radius: 30px;
    background-color: #e2f8ed;
  }
`;

export const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1; /* ← fills remaining space between header and footer */
  margin-top: 5px;
`;

export const UploadBox = styled.label<{ $dragEnter?: boolean }>`
  width: 200px;
  height: 200px;
  border-radius: 30px;
  border: 2px dashed #cbd0dc;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  padding: 20px;

  ${({ $dragEnter }) =>
    $dragEnter &&
    `
    transition: 0.4s;
    transition-timing-function: ease-in-out;
    border-color: black;
    box-shadow: 0px 0px 8px 3px #ebecea;
  `}

  &:hover {
    transition: 0.4s;
    transition-timing-function: ease-in-out;
    border-color: black;
    box-shadow: 0px 0px 8px 3px #ebecea;
  }
`;

export const UploadInfo = styled(Typography)`
  && {
    font-size: 12px;
    color: gray;
    margin-top: 10px;
  }
`;

export const ErrorText = styled(Typography)`
  && {
    color: red;
    font-size: 12px;
  }
`;

export const UploadFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

export const PrimaryButton = styled(Button)`
  && {
    background-color: black;
    color: white;
    border: 1px solid black;
    font-weight: 700;
    &:hover {
      background-color: white;
      color: black;
    }
    &:disabled {
      background-color: #e0e0e0;
      color: #a0a0a0;
      border-color: #e0e0e0;
    }
  }
`;

export const SecondaryButton = styled(Button)`
  && {
    background-color: white;
    color: black;
    border: 1px solid black;
    font-weight: 700;
    &:hover {
      background-color: black;
      color: white;
    }
  }
`;
